/* eslint-disable import/prefer-default-export */
export const PERMISSIONS = {
  HOME_VIEW: 1,
  TRIKE_VIEW: 2,
  BATTERY_VIEW: 3,
  TRIP_VIEW: 4,
  DRIVER_VIEW: 5,
  PARTNER_VIEW: 6,
  LOCATIONS_VIEW: 7,
  INVENTORY_VIEW: 8,
  SERVICE_VIEW: 9,
  QRCODE_VIEW: 10,
  TRIKE_VIEW_AND_EDIT: 11,
  TRIKE_NO_ACCESS: 12,
  TRIKE_ADD: 13,
  TRIKE_EDIT: 14,
  TRIKE_DELETE: 15,
  TRIKE_DISPATCH_AND_MOVE: 16,
  TRACKER_SWITCH: 17,
  TRIKE_MOBILISE: 18,
  TRIKE_CHECKLIST_ADD: 19,
  TRIKE_CHECKLIST_EDIT: 20,
  TRIKE_CHECKLIST_DELETE: 21,
  TRIKE_GEOFENCE_ADD: 22,
  TRIKE_GEOFENCE_EDIT: 23,
  TRIKE_GEOFENCE_DELETE: 24,
  TRIKE_ISSUE_ADD: 25,
  TRIKE_ISSUE_VIEW: 26,
  TRIKE_ADD_TO_SERVICE: 27,
  TRIKE_NO_SERVICE: 28,
  TRIKE_VIEW_QR: 29,
  TRIKE_NO_QR: 30,
  BATTERY_VIEW_AND_EDIT: 31,
  BATTERY_NO_ACCESS: 32,
  BATTERY_ADD: 33,
  BATTERY_EDIT: 34,
  BATTERY_DELETE: 35,
  BATTERY_ADD_TO_SERVICE: 36,
  BATTERY_NO_SERVICE: 37,
  BATTERY_VIEW_QR: 38,
  BATTERY_NO_QR: 39,
  TRIP_VIEW_AND_EDIT: 40,
  TRIP_NO_ACCESS: 41,
  TRIP_CREATE: 42,
  TRIP_EDIT: 43,
  TRIP_DELETE: 44,
  TRIP_MANUAL_END: 45,
  TRIP_STOP_DETAILS: 46,
  TRIP_NO_STOP_DETAILS: 47,
  DRIVER_VIEW_AND_EDIT: 48,
  DRIVER_NO_ACCESS: 49,
  DRIVER_ADD: 50,
  DRIVER_EDIT: 51,
  DRIVER_DELETE: 52,
  DRIVER_SUSPEND: 53,
  PARTNER_VIEW_AND_EDIT: 54,
  PARTNER_NO_ACCESS: 55,
  PARTNER_ADD: 56,
  PARTNER_EDIT: 57,
  PARTNER_DELETE: 58,
  PARTNER_VIEW_QR: 59,
  PARTNER_NO_QR: 60,
  PARTNER_EXPORT: 61,
  PARTNER_NO_EXPORT: 62,
  LOCATION_VIEW_AND_EDIT: 63,
  LOCATION_NO_ACCESS: 64,
  LOCATION_ADD: 65,
  LOCATION_EDIT: 66,
  LOCATION_DELETE: 67,
  INVENTORY_NO_ACCESS: 68,
  SERVICE_VIEW_AND_EDIT: 69,
  SERVICE_NO_ACCESS: 70,
  SERVICE_EDIT: 71,
  SERVICE_COMPLETE: 72,
  SETTINGS_GENERAL_VIEW_AND_EDIT: 73,
  SETTINGS_GENERAL_VIEW: 74,
  SETTINGS_PERSONALISATION: 75,
  SETTINGS_NO_PERSONALISATION: 76,
  SETTINGS_SYSTEM_USER_VIEW_AND_EDIT: 77,
  SETTINGS_SYSTEM_USER_VIEW: 78,
  SETTINGS_SYSTEM_USER_NO_ACCESS: 79,
  SETTINGS_SYSTEM_USER_CREATE: 80,
  SETTINGS_SYSTEM_USER_EDIT: 81,
  SETTINGS_SYSTEM_USER_DELETE: 82,
  SETTINGS_ROLE_CREATE: 83,
  SETTINGS_ROLE_EDIT: 84,
  SETTINGS_ROLE_DELETE: 85,
  BATTERY_REQUEST: 86,
  BATTERY_NO_REQUEST: 87,
  CHARGER_VIEW_AND_EDIT: 88,
  CHARGER_VIEW: 89,
  CHARGER_NO_ACCESS: 90,
  CHARGER_ADD: 91,
  CHARGER_EDIT: 92,
  CHARGER_DELETE: 93,
  REVENUE_VIEW_AND_EDIT: 94,
  REVENUE_VIEW: 95,
  REVENUE_NO_ACCESS: 96,
  REVENUE_MODIFY_PAYMENT: 97,
  REVENUE_NO_MODIFY_PAYMENT: 98,
  RATE_VIEW_AND_EDIT: 99,
  RATE_VIEW: 100,
  RATE_NO_ACCESS: 101,
  RATE_ADD: 102,
  RATE_EDIT: 103,
  RATE_DELETE: 104,
  APP_VIEW_AND_EDIT: 105,
  APP_NO_ACCESS: 106,
  POWER_AFRICA_ASSET_VIEW: 107,
  POWER_AFRICA_ASSET_VIEW_AND_EDIT: 108,
  POWER_AFRICA_ASSET_NO_ACCESS: 109,
  POWER_AFRICA_ASSET_ADD: 110,
  POWER_AFRICA_ASSET_EDIT: 111,
  POWER_AFRICA_ASSET_DELETE: 112,
  POWER_AFRICA_ASSET_CHECKLIST_ADD: 113,
  POWER_AFRICA_ASSET_CHECKLIST_EDIT: 114,
  POWER_AFRICA_ASSET_CHECKLIST_DELETE: 115,
  POWER_AFRICA_ASSET_ISSUE_ADD: 116,
  POWER_AFRICA_ASSET_ISSUE_VIEW: 117,
  POWER_AFRICA_ASSET_ADD_TO_SERVICE: 118,
  POWER_AFRICA_ASSET_NO_SERVICE: 119,
  POWER_AFRICA_ASSET_VIEW_QR: 120,
  POWER_AFRICA_ASSET_NO_QR: 121,
  APP_HUB_MANAGER_VIEW: 122,
  APP_NO_HUB_MANAGER_VIEW: 123,
  APP_POWER_AFRICA_AGENT_VIEW: 124,
  APP_NO_POWER_AFRICA_AGENT_VIEW: 125,
  SESSION_VIEW: 126,
  SESSION_VIEW_AND_EDIT: 127,
  SESSION_NO_ACCESS: 128,
  SESSION_CREATE: 129,
  SESSION_EDIT: 130,
  SESSION_DELETE: 131,
  REQUEST_VIEW: 132,
  REQUEST_VIEW_AND_EDIT: 133,
  REQUEST_NO_ACCESS: 134,
  ENERGY_MANAGEMENT_VIEW_AND_EDIT: 135,
  ENERGY_MANAGEMENT_VIEW: 136,
  ENERGY_MANAGEMENT_NO_ACCESS: 137,
  ENERGY_MANAGEMENT_MODIFY_SUPPLY: 138,
  ENERGY_MANAGEMENT_NO_MODIFY_SUPPLY: 139,
  ENERGY_MANAGEMENT_MODIFY_STORAGE: 140,
  ENERGY_MANAGEMENT_NO_MODIFY_STORAGE: 141,
  ENERGY_MANAGEMENT_MODIFY_ENERGY: 142,
  ENERGY_MANAGEMENT_NO_MODIFY_ENERGY: 143,
  RENTAL_VIEW: 144,
  RENTAL_VIEW_AND_EDIT: 145,
  RENTAL_NO_ACCESS: 146,
  RENTAL_MODIFY: 147,
  RENTAL_NO_MODIFY: 148,
};

export const SEED_ROLES = {
  SUPER_ADMIN: 1,
  DRIVER: 2,
  HUB_MANAGER: 3,
};

export const ITEM_STATUS = {
  DELETED: 0,
  ACTIVE: 1,
  RETIRED: 2,
};

export const TENANT_PERMISSIONS = {
  TRIKE_MODULE_ACCESS: 1,
  TRIKE_MODULE_NO_ACCESS: 2,
  TRIKE_MODIFY_ACCESS: 3,
  TRIKE_MODIFY_NO_ACCESS: 4,
  TRIKE_OVERRIDE_ACCESS: 5,
  TRIKE_OVERRIDE_NO_ACCESS: 6,
  TRIKE_CHECKLIST_ACCESS: 7,
  TRIKE_CHECKLIST_NO_ACCESS: 8,
  TRIKE_GEOFENCE_ACCESS: 9,
  TRIKE_GEOFENCE_NO_ACCESS: 10,
  TRIKE_ISSUE_ACCESS: 11,
  TRIKE_ISSUE_NO_ACCESS: 12,
  TRIKE_ADD_TO_SERVICE_ACCESS: 13,
  TRIKE_ADD_TO_SERVICE_NO_ACCESS: 14,
  TRIKE_QR_CODE_ACCESS: 15,
  TRIKE_NO_QR_CODE_ACCESS: 16,
  POWER_AFRICA_ASSET_MODULE_ACCESS: 17,
  POWER_AFRICA_ASSET_MODULE_NO_ACCESS: 18,
  POWER_AFRICA_ASSET_MODIFY_ACCESS: 19,
  POWER_AFRICA_ASSET_MODIFY_NO_ACCESS: 20,
  POWER_AFRICA_ASSET_CHECKLIST_ACCESS: 21,
  POWER_AFRICA_ASSET_CHECKLIST_NO_ACCESS: 22,
  POWER_AFRICA_ASSET_ISSUE_ACCESS: 23,
  POWER_AFRICA_ASSET_ISSUE_NO_ACCESS: 24,
  POWER_AFRICA_ASSET_ADD_TO_SERVICE_ACCESS: 25,
  POWER_AFRICA_ASSET_ADD_TO_SERVICE_NO_ACCESS: 26,
  POWER_AFRICA_ASSET_QR_CODE_ACCESS: 27,
  POWER_AFRICA_ASSET_NO_QR_CODE_ACCESS: 28,
  BATTERY_MODULE_ACCESS: 29,
  BATTERY_MODULE_NO_ACCESS: 30,
  BATTERY_MODIFY_ACCESS: 31,
  BATTERY_MODIFY_NO_ACCESS: 32,
  BATTERY_REQUEST_ACCESS: 33,
  BATTERY_REQUEST_NO_ACCESS: 34,
  BATTERY_ADD_TO_SERVICE_ACCESS: 35,
  BATTERY_ADD_TO_SERVICE_NO_ACCESS: 36,
  BATTERY_QR_CODE_ACCESS: 37,
  BATTERY_NO_QR_CODE_ACCESS: 38,
  CHARGER_MODULE_ACCESS: 39,
  CHARGER_MODULE_NO_ACCESS: 40,
  CHARGER_MODIFY_ACCESS: 41,
  CHARGER_MODIFY_NO_ACCESS: 42,
  TRIP_MODULE_ACCESS: 43,
  TRIP_MODULE_NO_ACCESS: 44,
  TRIP_MODIFY_ACCESS: 45,
  TRIP_MODIFY_NO_ACCESS: 46,
  TRIP_OVERRIDE_ACCESS: 47,
  TRIP_OVERRIDE_NO_ACCESS: 48,
  TRIP_STOP_DETAILS_ACCESS: 49,
  TRIP_STOP_DETAILS_NO_ACCESS: 50,
  SESSION_MODULE_ACCESS: 51,
  SESSION_MODULE_NO_ACCESS: 52,
  SESSION_MODIFY_ACCESS: 53,
  SESSION_MODIFY_NO_ACCESS: 54,
  DRIVER_MODULE_ACCESS: 55,
  DRIVER_MODULE_NO_ACCESS: 56,
  DRIVER_MODIFY_ACCESS: 57,
  DRIVER_MODIFY_NO_ACCESS: 58,
  DRIVER_OVERRIDE_ACCESS: 59,
  DRIVER_OVERRIDE_NO_ACCESS: 60,
  PARTNER_MODULE_ACCESS: 61,
  PARTNER_MODULE_NO_ACCESS: 62,
  PARTNER_MODIFY_ACCESS: 63,
  PARTNER_MODIFY_NO_ACCESS: 64,
  PARTNER_QR_CODE_ACCESS: 65,
  PARTNER_QR_CODE_NO_ACCESS: 66,
  PARTNER_EXPORT_ACCESS: 67,
  PARTNER_EXPORT_NO_ACCESS: 68,
  LOCATION_MODULE_ACCESS: 69,
  LOCATION_MODULE_NO_ACCESS: 70,
  LOCATION_MODIFY_ACCESS: 71,
  LOCATION_MODIFY_NO_ACCESS: 72,
  SERVICE_MODULE_ACCESS: 73,
  SERVICE_MODULE_NO_ACCESS: 74,
  SERVICE_MODIFY_ACCESS: 75,
  SERVICE_MODIFY_NO_ACCESS: 76,
  REVENUE_MODULE_ACCESS: 77,
  REVENUE_MODULE_NO_ACCESS: 78,
  REVENUE_MODIFY_ACCESS: 79,
  REVENUE_MODIFY_NO_ACCESS: 80,
  RATE_MODULE_ACCESS: 81,
  RATE_MODULE_NO_ACCESS: 82,
  RATE_MODIFY_ACCESS: 83,
  RATE_MODIFY_NO_ACCESS: 84,
  MOBILE_APP_ACCESS: 85,
  MOBILE_APP_NO_ACCESS: 86,
  ENERGY_MANAGEMENT_MODULE_ACCESS: 87,
  ENERGY_MANAGEMENT_MODULE_NO_ACCESS: 88,
  ENERGY_MANAGEMENT_MODIFY_SUPPLY_ACCESS: 89,
  ENERGY_MANAGEMENT_MODIFY_SUPPLY_NO_ACCESS: 90,
  ENERGY_MANAGEMENT_MODIFY_STORAGE_ACCESS: 91,
  ENERGY_MANAGEMENT_MODIFY_STORAGE_NO_ACCESS: 92,
  ENERGY_MANAGEMENT_MODIFY_ENERGY_ACCESS: 93,
  ENERGY_MANAGEMENT_MODIFY_ENERGY_NO_ACCESS: 94,
  REQUEST_MODULE_ACCESS: 95,
  REQUEST_MODULE_NO_ACCESS: 96,
  REQUEST_MODIFY_ACCESS: 97,
  REQUEST_MODIFY_NO_ACCESS: 98,
  RENTAL_MODULE_ACCESS: 99,
  RENTAL_MODULE_NO_ACCESS: 100,
  RENTAL_MODIFY_ACCESS: 101,
  RENTAL_MODIFY_NO_ACCESS: 102,
};

export const TENANT_RULE_VALUE = {
  CHECKLIST: 1,
  KNOWN_ISSUES: 2,
  QR_CODE: 3,
};

export const DEFAULT_LAT = -0.6803741;
export const DEFAULT_LONG = 34.7569482;
